import React, { useState, useRef } from "react";
import HeaderPage from "./HeaderPage";
import "./RealtimeVideo.css";
import watermarkImageUrl from "../assets/images/tubewatermark.png";
import bharat_video from "../assets/images/BharatTube.png";
import madeinBharat from "../assets/images/madeinBharatLogo.png";
import poster from "../assets/images/pm_poster.jpg";

import { CirclesWithBar } from "react-loader-spinner";

const LanguageList = {
  "en-IN": "English",
  "hi-IN": "हिंदी [Hindi]",
  "te-IN": "తెలుగు [Telugu]",
  "ta-IN": "தமிழ் [Tamil]",
  "kn-IN": "ಕನ್ನಡ [Kannada]",
  "ml-IN": "മലയാളം [Malayalam]",
  "mr-IN": "मराठी [Marathi]",
  "gu-IN": "ગુજરાતી [Gujarati]",
  "bn-IN": "বাঙ্গালি [Bengali]",
  "ur-IN": "اردو [Urdu]",
  "ru-RU": "Русский [Russian]",
  "es-ES": "Español [Spanish]",
  "fr-BE": "Français [French]",
  "zh-TW": "中国人 [Chinese]",
  "ar-AE": "عربي [Arabic]",
  "pt-PT": "Português [Portuguese]",
  "su-ID": "basa Sunda [Sundanese]",
  "de-AT": "Deutsch [German]",
  "ja-JP": "日本 [Japanese]",
  "ko-KR": "한국인 [Korean]",
  "it-IT": "Italiano [Italian]",
  "tr-TR": "Türkçe [Turkish]",
  "ms-MY": "Melayu [Malay]",
  "ps-AF": "پښتو [Pashto]",
};

const TargetLanguageList = {
  "en-IN": "English",
  "hi-IN": "हिंदी [Hindi]",
  "te-IN": "తెలుగు [Telugu]",
  "ta-IN": "தமிழ் [Tamil]",
  "kn-IN": "ಕನ್ನಡ [Kannada]",
  "ml-IN": "മലയാളം [Malayalam]",
  "mr-IN": "मराठी [Marathi]",
  "gu-IN": "ગુજરાતી [Gujarati]",
  "bn-IN": "বাঙ্গালি [Bengali]",
  "ur-IN": "اردو [Urdu]",
  "or-IN": "ଓଡ଼ିଆ [Oriya]",
  "ru-RU": "Русский [Russian]",
  "es-ES": "Español [Spanish]",
  "fr-BE": "Français [French]",
  "zh-TW": "中国人 [Chinese]",
  "ar-AE": "عربي [Arabic]",
  "pt-PT": "Português [Portuguese]",
  "su-ID": "basa Sunda [Sundanese]",
  "de-AT": "Deutsch [German]",
  "ja-JP": "日本 [Japanese]",
  "ko-KR": "한국인 [Korean]",
  "it-IT": "Italiano [Italian]",
  "tr-TR": "Türkçe [Turkish]",
  "ms-MY": "Melayu [Malay]",
};

function LoadingAnimation() {
  return (
    <div className="loading-overlay">
      <div className="load">
        <CirclesWithBar
          height="100"
          width="100"
          color="#4fa94d"
          outerCircleColor="#4fa94d"
          innerCircleColor="#4fa94d"
          barColor="#4fa94d"
          ariaLabel="circles-with-bar-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <h4>Loading...</h4>
      </div>
    </div>
  );
}

const DEBUG = false;

function RealtimeVideo() {
  const [videoUrl, setVideoUrl] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("en-IN");
  const [sourceLanguage, setSourceLanguage] = useState("en-IN");
  const [loading, setLoading] = useState(false);
  const [translatedAudioUrl, setTranslatedAudioUrl] = useState("");
  const [translatedVideoUrl, setTranslatedVideoUrl] = useState("");

  const videoRef = useRef(null);
  const audioRef = useRef(null);

  // const LIVE_ENDPOINT = "https://bharattube.aicte-india.org/api/realtime";
  const LIVE_ENDPOINT = "https://neo.futurixai.com";
  const LOCALHOST_ENDPOINT = "http://10.150.0.6:6969"; // For testing

  const endpoint = DEBUG ? LOCALHOST_ENDPOINT : LIVE_ENDPOINT;

  const handleTranslateClick = async () => {
    // check if video url is empty
    if (videoUrl === "") {
      alert("Please enter a valid YouTube video URL");
      return;
    }

    // check if source language is same as target language
    if (sourceLanguage === targetLanguage) {
      alert("Source language and target language cannot be same");
      return;
    }

    setLoading(true);
    const body = JSON.stringify({
      url: videoUrl,
      target_lang: targetLanguage,
      input_lang: sourceLanguage,
    });

    try {
      const [videoResponse, audioResponse] = await Promise.all([
        fetch(`${endpoint}/get_video`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: body,
        }),
        fetch(`${endpoint}/process_video`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: body,
        }),
      ]);

      const [videoBlob, audioBlob] = await Promise.all([
        videoResponse.blob(),
        audioResponse.blob(),
      ]);

      setTranslatedVideoUrl(URL.createObjectURL(videoBlob));
      setTranslatedAudioUrl(URL.createObjectURL(audioBlob));
    } catch (error) {
      console.error("Error:", error);
    }

    setLoading(false);
  };

  // Synchronization functions for audio and video
  const syncPlay = () => {
    if (audioRef.current && videoRef.current) {
      const currentTime = videoRef.current.currentTime;
      audioRef.current.currentTime = currentTime;
      audioRef.current.play();
    }
  };

  const syncPause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const syncSeek = () => {
    if (audioRef.current && videoRef.current) {
      const currentTime = videoRef.current.currentTime;
      audioRef.current.currentTime = currentTime;
    }
  };

  const textWatermark = "Anuvadini";

  const handleRightClick = (event) => {
    event.preventDefault();
    // alert("DO NOT COPY");
  };

  return (
    <>
      <HeaderPage />
      <img
        src={poster}
        alt="poster"
        style={{
          width: "100%",
        }}
      />
      <section className="realTimeVideoSec reltimevideosenew">
        <div className="container">
          <div className="realtimevideoCnt">
            <div
              className="sesnLogoDiv cntnrLogo"
              style={{
                display: "flex",
                alignContent: "flex-start",
                justifyContent: "center",
              }}
            >
              <img src={bharat_video} style={{ height: "14vh" }} alt="logo" />{" "}
              <img
                className="madeInBhrt"
                src={madeinBharat}
                style={{ height: "10vh" }}
                alt="logo"
              />
            </div>
            <div className="videoSldrCnt">
              <h2>
                Bharat Tube : YouTube videos in Bharatiya (Indian) languages
              </h2>
              <p>
                As the sun rises over the Ganges, BharatTube begins its daily
                dance of digital alchemy. BharatTube revolutionizes the viewing
                experience by translating YouTube videos into a variety of
                Indian languages, from Hindi's lyrical flow to Tamil's depth. It
                enables users across India, like a Kerala villager or Mumbai
                youths, to enjoy global content in their native languages,
                enhancing understanding and enjoyment. The platform serves as a
                cultural nexus, seamlessly blending international content with
                local linguistic essence, making it universally accessible and
                relatable. More than just a translation tool, BharatTube is a
                cultural interpreter, ensuring authenticity in every translated
                emotion and joke. As a digital bridge connecting diverse stories
                and voices, BharatTube underscores technology's role in uniting
                people across linguistic and cultural divides.
              </p>
              <p>
                Here, the world's stories, in all their varied hues, find a new
                voice. A YouTube video, perhaps a lecture by an esteemed
                professor or a documentary about distant galaxies, lands gently
                in the hands of BharatTube. With a flourish of technological
                wizardry, the platform works its magic, transforming the YouTube
                video into a symphony of Indian (Bharatiya) languages - Hindi's
                lyrical cadences, Bengali's melodious rhythms, Tamil's rich
                tones, and many more.
              </p>
              <p>
                In a small village in Kerala, an elderly man watches in awe as
                the secrets of the universe, spoken in English, unravel in his
                native Malayalam. His eyes, reflecting a universe of stars,
                twinkle with understanding and wonder. In a bustling café in
                Mumbai, a group of young friends gather around a phone, laughing
                and marveling as a popular English sitcom finds its voice in
                Marathi, the humor perfectly intact.
              </p>
              <p>
                BharatTube becomes a canvas where international content meets
                local flavor, creating a mosaic of global knowledge and
                entertainment, accessible to all. It's a place where barriers
                dissolve, where the American vlogger speaks in Punjabi, the
                Korean pop group sings in Gujarati, and the French chef teaches
                cooking in Telugu.
              </p>
              <p>
                But BharatTube is more than a mere translation tool; it is a
                cultural chameleon, understanding the nuances and subtleties of
                each language, ensuring that every emotion, joke, and piece of
                wisdom is conveyed with authenticity. It fosters a world where
                knowledge and joy are not limited by language, where the beauty
                of diversity is celebrated through the universal language of
                video.
              </p>
              <p>
                As the evening sets in, and the screens go dark, BharatTube
                rests, having woven another day's tapestry of interconnected
                stories. It stands as a testament to the power of technology in
                bridging hearts and minds, proving that in the rich tapestry of
                human expression, every voice matters, every story counts.
              </p>
            </div>
            <div
              style={{
                fontSize: "1rem",
                fontWeight: "bold",
                color: "red",
                margin: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              NOTE: The maximum supported video length is 20 minutes. Longer
              videos may not be processed.
            </div>
            {
              <div className="inputGroup">
                <input
                  type="text"
                  placeholder="Enter YouTube video URL"
                  value={videoUrl}
                  onChange={(e) => setVideoUrl(e.target.value)}
                />
                <select onChange={(e) => setSourceLanguage(e.target.value)}>
                  <option value="" disabled selected>
                    Select a source language
                  </option>
                  {Object.keys(LanguageList).map((key) => (
                    <option key={key} value={key}>
                      {LanguageList[key]}
                    </option>
                  ))}
                </select>

                {/* <label>Target Language: </label> */}
                <select onChange={(e) => setTargetLanguage(e.target.value)}>
                  <option value="" disabled selected>
                    Select a target language
                  </option>
                  {Object.keys(TargetLanguageList).map((key) => (
                    <option key={key} value={key}>
                      {TargetLanguageList[key]}
                    </option>
                  ))}
                </select>
                <button onClick={handleTranslateClick} className="translBtn">
                  Translate
                </button>
              </div>
            }
            {loading ? (
              <LoadingAnimation />
            ) : (
              translatedAudioUrl &&
              translatedVideoUrl && (
                <div
                  className="videoAudioPlayer"
                  style={{ position: "relative" }}
                >
                  <video
                    ref={videoRef}
                    width="100%"
                    height="auto"
                    controls
                    onPlay={syncPlay}
                    onPause={syncPause}
                    onSeeked={syncSeek}
                    src={translatedVideoUrl}
                    onContextMenu={handleRightClick} //
                  ></video>
                  <img
                    src={watermarkImageUrl}
                    alt="Watermark"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      opacity: 0.8,
                      height: "6vw",
                      pointerEvents: "none", // To allow interaction with video
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: "white",
                      opacity: 0.8,
                      pointerEvents: "none",
                      fontWeight: "bold",
                      fontSize: "5vw",
                      maxWidth: "100%",
                    }}
                  >
                    {textWatermark}
                  </div>
                  <audio
                    ref={audioRef}
                    src={translatedAudioUrl}
                    style={{ display: "none" }}
                  ></audio>
                </div>
              )
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default RealtimeVideo;
